export default __webpack_public_path__ + "static/media/question-mark.7ccd8372.svg";